import { useNavigate } from 'react-router-dom';
import { useOnboardingStepsAtom } from 'atoms';
import { APP_ROUTES } from '../../../constants';

function HSAUploadSuccess() {
  const navigate = useNavigate();
  const { setCurrentStep } = useOnboardingStepsAtom();

  const onClose = () => {
    setCurrentStep(0);
    navigate(APP_ROUTES.SETTINGS);
  };

  // JSX
  return (
    <div className="flex justify-center items-center pt-12">
      <div className="text-center p-8">
        <div className="relative my-8 h-1/3 flex justify-center items-center">
          <img
            src={`${process.env.PUBLIC_URL}/static/img/final_circle.svg`}
            alt="circle"
            className="w-[100px] h-[100px]"
          />
          <img
            src={`${process.env.PUBLIC_URL}/static/img/final_checkmark.svg`}
            alt="checkmark"
            className="w-[52px] h-[52px] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
          />
        </div>

        <div className="space-y-6">
          <h1 className="capitalize text-3xl">
            calculating historical savings assessment...
          </h1>
          <div className="space-y-6 w-[500px] m-auto">
            <div>
              <p>
                We{"'"}re analyzing your data to calculate potential savings.
              </p>
              <p className="font-semibold">
                Your HSA will be delivered within 4 - 5 hours.
              </p>
            </div>
            <div>
              <p>You can safely close this window.</p>
              <p>
                We{"'"}ll email you the results when they{"'"}re ready.
              </p>
            </div>
          </div>
          <div className="h-1/3 flex justify-center items-center">
            <button
              onClick={onClose}
              className="mt-4 px-6 py-2 bg-success text-light text-lg capitalize font-bold rounded-[20px]"
            >
              close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HSAUploadSuccess;
